var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chat-audio",on:{"click":_vm.handleClick}},[_c('span',[_vm._v(_vm._s(_vm.second)+"\"")]),_vm._v(" "),_c('voice-icon',{staticClass:"icon",attrs:{"color":_vm.isSend ? '#ffffff' : '#193a79',"direction":_vm.isSend ? 'left' : 'right',"active":_vm.playStatus}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7170fdbc","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/chatAudio.vue
// module id = null
// module chunks = 